import { takeEvery, call, put, select } from 'redux-saga/effects'
import { TOGGLE_HIDE_ENDED, TOGGLE_SELECTED_TRACK, toggleSelectedTrack } from '../../store/Tracks/actions'
import { buildGETUrl } from '../../utilities/buildGETUrl'
import { showAlertError, showAlertInfo } from '../../store/Alert/actions'
import { LOAD_INDENT_OBJECTS, putIndentObjects } from '../../store/Objects/actions'
import axios from 'axios'
import { generateStateKey } from "../../utilities/generateStateKey";
import { putClips, putClipsAll } from "../../store/Settings/actions/components/Clips";
import moment from "moment";
import { formatMinutesToTime } from "../../components/Settings/utilities/formatTime";
import { objectSort } from './loadObjects'
import { compareScheduleItems } from '../Settings/Clips/loadClips'

export default function* () {
    yield takeEvery(LOAD_INDENT_OBJECTS, worker)
    yield takeEvery(TOGGLE_SELECTED_TRACK, worker)
    yield takeEvery(TOGGLE_HIDE_ENDED, worker)
}

function* worker({ type, payload }) {


    //Отловим нажатие показать/скрыть завершённые
    if (type === TOGGLE_HIDE_ENDED) {

        //Если показать, то нам не интересно
        if (!payload)
            return

        //Если скрыть, то убирам из выбранных завершённые
        try {
            const selectedIndents = yield select(state => state.tracks.selected)

            if (!!!selectedIndents.length)
                return;

            const selectedIndentsCopy = [...selectedIndents];
            const allTracks = yield select(state => state.tracks.tracks)


            allTracks.forEach(track => {
                const selectedTrackIndex = selectedIndentsCopy.indexOf(track.id);
                if (track.clipEnded && selectedTrackIndex !== -1) {
                    delete selectedIndentsCopy[selectedTrackIndex];
                }
            })

            //Если если таковые оказались, уберём их из выбранных
            if (selectedIndentsCopy.length !== selectedIndents.length)
                yield put(toggleSelectedTrack({ ids: selectedIndentsCopy }))

        } catch (e) {

        }


        return;
    }

    try {
        const allObjectsAssociated = yield select(state => state.objects.allObjectsAssociated)
        const selectedIndents = yield select(state => state.tracks.selected)



        const clip_review =
            (Array.isArray(selectedIndents) && selectedIndents[0])
                ? yield call(fetchClips, selectedIndents)
                : {}

        if (clip_review.error) {
            yield put(showAlertError({
                errors: [`Ошибка сервера при ${LOAD_INDENT_OBJECTS}.`, clip_review],
                text: "Объекты не были загружены. Попробуйте повторить."
            }))
            yield put(putIndentObjects([]))

        } else {
            if (clip_review.warning) {
                yield put(
                    showAlertInfo({
                        text: clip_review.warning,
                    })
                );
            }
            if (clip_review.success) {



                const indentObjectsIds = [
                    ...new Set(
                        Object.values(clip_review.success.indent)
                            .flatMap(({ ms }) => Object.keys(ms).map(Number))
                    )
                ];

                const indentObjects = indentObjectsIds.map(el => allObjectsAssociated[el])

                let statusList = yield select(state => state.objects.statusList)
                const statusObject = statusList.reduce((acc, current) => {
                    acc[current.id] = current.name;
                    return acc;
                }, {})

                let objectsSorted = objectSort(indentObjects, statusObject)


                yield put(putIndentObjects(objectsSorted))

            } else {
                yield put(putIndentObjects([]))
            }
        }
    } catch (e) {
        yield put(showAlertError({
            errors: [`Ошибка сети при ${LOAD_INDENT_OBJECTS}.`, e],
            text: "Объекты не были загружены. Попробуйте повторить."
        }))
        yield put(putIndentObjects([]))
    }
}

// function fetchClips(indentId) {
//     return axios.get("/timeline/clip/select", { params: { indent_id: indentId } })
//         .then(response => response.data)
// }


function fetchClips(indentIds) {
    const formData = new FormData();
    // Добавляем каждый элемент массива в FormData
    indentIds.forEach(id => formData.append('indent_id[]', id.toString()));


    return axios(
        {
            url: `/timeline/clip/review`,
            method: "POST",
            data: formData,
        }
    )
        .then(response => response.data)
}

